import './epg.css';
import React, { Component } from 'react';
import Translator from './../../requests/apa/Translator';
import EpgHeader from './../../components/Epg/EpgHeader';
import EpgGrid from './../../components/Epg';
import EpgPostales from './../../components/Epg/EpgPostalesFull';
import ChannelGrid from './../../components/Epg/EpgGrid';
import Resume from './../../components/Resume';
import Utils from '../../utils/Utils';
import { connect } from 'react-redux';
import { setResumeData } from '../../actions/resume';
import { playFullMedia, playPipMedia } from '../../actions/playmedia';
import { showNotification } from '../../actions/notification';
import {Dates} from '../../packages/dates';
import * as playerConstant from '../../utils/playerConstants';
import store from './../../store';
import NagraUtil from './../../devices/nagra/NagraUtil';
import Device from '../../devices/device';
import {IPTV} from './../../devices/all/settings';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import CodeToVal from '../../utils/CodeToVal';
import Metadata from '../../requests/apa/Metadata';
import Npvr from '../../utils/Npvr.js';
import { setMetricsEvent } from '../../actions/metrics';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import {
  showModal,
  MODAL_EPG,
  MODAL_CHANNEL_EPG,
  AAF_MODAL_ERROR,
  HIDE_MODAL,
} from '../../actions/modal';
import ReminderNotifications from '../../utils/RemindersNotifications/ReminderNotifications';
import ReminderCreateTask from '../../requests/tasks/user/ReminderCreateTask';
import { getLinksFromNavConfiguration } from '../../components/Header/index';
import LayersControl from '../../utils/LayersControl';
import RequestManager from './../../requests/RequestManager';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import ReminderDeleteTask from '../../requests/tasks/user/ReminderDeleteTask';
import LocalStorage from '../../components/DeviceStorage/LocalStorage';
import FullEpgPersistance from '../../components/FullEpgPersistance';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import { setLastTouchReminder } from '../../reducers/user';
import ModalEpgUtils from '../../components/Epg/ModalEpgUtils';
import EpgConstants from '../../AAF/Nepg/EpgConstants';
import PlayerStreamingUtils from '../../utils/PlayerStreamingUtils';
import * as api from '../../requests/loader';

class Epg extends Component {
  constructor(props) {
    super(props);

    this.epgContainer = null;
    this.filters = [];
    this.keyActionsEnabled = true;
    this.currentData = null;
    this.state = {
      showEpg: props.showEpg === null ? false : props.showEpg, //Esta variable ya no se usa, usamos directamente las props que se pasan desde el componente video
      filterCurrent: {
        node_id: null,
        index: 0
      },
      channels: null,
      moreInfoFunction: null,
      channelCurrent: {},
      messages: {
        isFavorite: {
          title: '¡Agregado!',
          message: 'Este canal ha sido agregado a tu lista de favoritos.'
        },
        isReminder: {
          title: '¡Agendado!',
          message: 'Te notificaremos cuando comience este programa.'
        },
        isBlocked: {
          title: '¡Bloqueado!',
          message: 'Este canal ha sido agregado a tu lista de canales bloqueados.'
        }
      }
    };

    this.loadedFilter = null;

    this.keys = Device.getDevice().getKeys();
    this.isInColors = false;
    this.currentPipFocused = null;
    this.currentPipPlaying = null;
    this.setResumeDataTimeoutId = null;

    this.timerDelayChannelChange = null;
    this.delayChannelChange = 1500;
    this.lastNumberPressed = '';
    this.maxLenNumberChannel = 4;
    this.codeToVal = new CodeToVal();

    this.toggleContent = this.toggleContent.bind(this);
    this.setFilter = this.setFilter.bind(this);
    this.setChannels = this.setChannels.bind(this);
    // this.setPrevFilter = this.setPrevFilter.bind(this);
    this.yellowHandler = this.yellowHandler.bind(this);
    this.redHandler = this.redHandler.bind(this);
    this.blueHandler = this.blueHandler.bind(this);

    // this.setNexFilter = this.setNexFilter.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.setResume = this.setResume.bind(this);
    this.playPipPlayer = this.playPipPlayer.bind(this);
    this.closePipPlayer = this.closePipPlayer.bind(this);
    this.closeFullPlayer = this.closeFullPlayer.bind(this);
    this.ifFirePip = this.ifFirePip.bind(this);
    this.killPipTimeout = this.killPipTimeout.bind(this);
    this.updateEpg = this.updateEpg.bind(this);
    this.enableKeyActions = this.enableKeyActions.bind(this);
    this.disableKeyActions = this.disableKeyActions.bind(this);
    this.setChannelInfo = this.setChannelInfo.bind(this);
    this.handleDelayKey = this.handleDelayKey.bind(this);
    this.handleMosaic = this.handleMosaic.bind(this);
    this.handleGuide = this.handleGuide.bind(this);
    this.handleRed = this.handleRed.bind(this);

    this.platform = Device.getDevice().getPlatform();
    this.updateFilter = props.updateFilter || null;
    this.node_id = props.node_id || null;

    this.pipTimeout = null;

    this.channelsFlag = this.props.channelsFlag;
    this.playerStreamingUtils = new PlayerStreamingUtils();
    this.sendVirtualPage('menu tv');
  }

  ifFirePip() {
    return this.platform === 'nagra' || this.platform === 'workstation';
  }

  killPipTimeout() {
    if (this.pipTimeout) {
      clearTimeout(this.pipTimeout);
    }
  }

  getNagraUriByChannelKey(channelKey) {
    return NagraUtil.getNagraUriByChannelKey(channelKey);
  }

  playPipPlayer(currentFocused = {}) {
    // At this moment, pip only for workstation & nagra with DVBC, remove of below and test to extend to another devices
    if (!this.ifFirePip()) {
      return;
    }

    if (currentFocused.channel && currentFocused.channel.group_id) {
      if (this.currentPipFocused === currentFocused.channel.group_id) {
        // Nothing to do
        return;
      } else {
        // Handle PIP, streamType for now dvbc and only for nagra
        let streamType = Device.getDevice().getConfig().stream_type || 'hls_kr';
        // Force nagra to DVBC
        if (this.platform === 'nagra') {
          //streamType = playerConstant.HLSPRM;
          streamType = playerConstant.DVBC;
        }

        this.currentPipFocused = currentFocused.channel.group_id;

        // TODO For the moment, hard :/
        let video_url =
          'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4?gid=' +
          this.currentPipFocused +
          '&t=' +
          Math.random();

        let pgm = {};
        pgm.media = {};
        pgm.media.video_url = video_url;

        pgm.group = {};
        pgm.group.common = {};
        pgm.group.common.image_background = null;
        pgm.group.common.id = currentFocused.channel.group_id;

        if (this.platform === 'nagra') {
          //video_url = 'http://184.72.239.149/vod/smil:BigBuckBunny.smil/playlist.m3u8?t=' + Math.random();
          //let cableSourceUri = this.getNagraUriByChannelKey(pgm.media.video_url);
          //pgm.media.video_url = cableSourceUri;
          let channel_url_from_CSV = Utils.getChannelUrl(currentFocused.channel.group_id);
          pgm.media.video_url = channel_url_from_CSV;
          console.log(
            '>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ',
            channel_url_from_CSV
          );

          /*
let random_dvbc = null;
let hard_options = ['tv://channel.00a0001f0003', 'tv://channel.00a0001f0002'];
random_dvbc = Math.floor(Math.random() * 2);
if(random_dvbc > 1) {
  random_dvbc = 0;
}
pgm.media.video_url = hard_options[random_dvbc];
*/

          // For test
          //pgm.media.video_url = 'http://184.72.239.149/vod/smil:BigBuckBunny.smil/playlist.m3u8';
          pgm.media.server_url = null;
          pgm.media.challenge = null;
        }

        this.killPipTimeout();
        // For nagra, need timeout, for other devices may be not
        this.pipTimeout = setTimeout(this.firePipPlayer, 2000, pgm, streamType);

        // TODO When we have the channelKey get the tv protocol
        //if(this.platform === 'nagra' && streamType === playerConstant.DVBC) {
        //pgm.media.video_url = NagraUtil.getNagraUriByChannelKey(pgm.media.video_url);
        //}

        /*
// Below if we need to add more devices to the pip, here we dont need timeout, timeout will be the time pgm send us response
this.currentPipPlaying = currentFocused.channel.group_id;
// There is no timeout to fire the pip, tiemout is the time while app gets response from PGM
api.playerGetMedia(this.currentPipPlaying, null, false, streamType).then((pgm) => {

  console.log('PIP currentDevice:', this.platform);
  console.log('PIP pgm:', pgm);
  console.log('PIP pgm gid:', pgm.group.common.id);
  console.log('PIP current gid playing:', this.currentPipPlaying);

  // Only plays the getmedia that match the current channel focused
  if(this.currentPipPlaying === pgm.group.common.id) {
    // Replace video url if nagra & CABLE
    if(this.platform === 'nagra' && streamType === playerConstant.DVBC) {
      pgm.media.video_url = NagraUtil.getNagraUriByChannelKey(pgm.media.video_url);
    }
    // Fire pip
    this.firePipPlayer(pgm, streamType);
  }
}).catch((e) => {
  console.log('Error when get PGM for channelID: ' + currentFocused.channel.group_id);
});
*/
      }
    }
  }

  firePipPlayer(pgm, streamType) {
    console.log('PIP firepip with options:', pgm, streamType);
    let drmInfo = null;
    if (pgm.media.server_url) {
      if (!drmInfo) drmInfo = {};
      drmInfo.server_url = pgm.media.server_url;
    }
    if (pgm.media.challenge) {
      if (!drmInfo) drmInfo = {};
      drmInfo.challenge = pgm.media.challenge;
    }

    let videoOptions = {
      drmInfo: drmInfo,
      src: pgm.media.video_url,
      streamType: streamType,
      isLive: true,
      resume: null,
      backgroundImage: pgm.group.common.image_background
        ? pgm.group.common.image_background
        : null,
      isTrailer: false,
      creditsTime: null,
      groupId: pgm.group.common.id,
      muted: true,
      controls: false
    };

    console.log('PIP firePIP:', videoOptions);
    store.dispatch(playPipMedia(videoOptions));
  }

  closePipPlayer() {
    console.log('@@@@@@@@@@@@ EPG container closePipPlayer');
    store.dispatch(playPipMedia({ src: null }));
  }

  closeFullPlayer() {
    console.log('@@@@@@@@@@@@ EPG container closeFullPlayer');
    store.dispatch(playFullMedia({ src: null, event: null }));
  }

  handleKeyPress(e) {
    if (LayersControl.isUXVisible()) return;

    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
    //console.log('[PAU]> Enter to Listening [container EPG] handleKeyPress, currentKey',currentKey);
    this.setAutoHideTimeout();

    if (!this.keyActionsEnabled) {
      return false;
    }

    //console.log('Listening container EPG Index', e.keyCode, currentKey);
    switch (currentKey) {
      case 'BACK':
        e.preventDefault();
        e.stopPropagation();
        console.log('[EPG] BACK isInColors', this.isInColors);
        let backToColors = DeviceStorage.getItem('config_remote_control') != 'simple';

        if (backToColors) {
          backToColors = Utils.getRegionaliazedMetadata(
            'back_colors_epg',
            '{"default":{"enable":true },"argentina":{"enable":false}}'
          ).enable;
        }
        if (backToColors && !this.isInColors) {
          if (Utils.isModalHide()) {
            window.SpatialNavigation.focus('.color-codes .focusable');
          }
          this.isInColors = true;
        } else {
          this.props.handleFullEpg();
          this.isInColors = false;
        }
        break;
      case 'OK':
        if (DeviceStorage.getItem('config_remote_control') === 'simple') {
          e.preventDefault();
          e.stopPropagation();
          this.handleDelayKey(e, currentKey);
        }
        break;
      case 'YELLOW':
        e.preventDefault();
        e.stopPropagation();
        this.yellowHandler();
        // this.setPrevFilter();
        break;
      case 'RED':
        e.preventDefault();
        e.stopPropagation();
        this.redHandler();
        break;
      case 'GREEN':
        e.preventDefault();
        e.stopPropagation();
        // this.setNexFilter();
        break;
      case 'MOSAIC':
        e.preventDefault();
        e.stopPropagation();

        this.handleMosaic();
        break;
      case 'MUSIC':
        //this.props.hideEpgOutside();
        break;
      case 'VOD':
        this.props.hideEpgOutside();
        break;
      case 'MENU':
        this.goToMenu();
        break;
      case 'ZERO':
      case 'ONE':
      case 'TWO':
      case 'THREE':
      case 'FOUR':
      case 'FIVE':
      case 'SIX':
      case 'SEVEN':
      case 'EIGHT':
      case 'NINE':
        this.handleChannelChange(e, this.codeToVal.getKeyValue(currentKey));
        break;
      case 'GUIDE':
        e.preventDefault();
        e.stopPropagation();
        this.handleGuide();
        break;
      default:
        //console.log('[containers/Epg] keypress epg', currentKey, ' code', e.keyCode);
        break;
    }
  }

  handleRed() {
    this.props.hideEpgOutside();
    this.sendMetric('buscar');
    this.props.goToCard('/search');
  }

  handleMosaic() {
    this.props.hideEpgOutside();
    ModalEpgUtils.showGridChannels({
        isFromKey: true
    });
  }

  handleGuide() {
    if (this.props.getEpgType) {
      if (this.props.getEpgType() === 'GUIDE') {
        this.props.handleFullEpg();
      } else {
        this.toggleContent();
      }
    }
  }

  handleDelayKey(e, key) {
    console.log('[Epg] handleDelayKey', this.isKeysBloqued, e.keyCode, key);
    e.stopPropagation();
    if (this.lastKey !== key && this.pressTimer) {
      clearTimeout(this.pressTimer);
    }
    this.isKeysBloqued = !!(this.lastKey === key && this.pressTimer);
    this.lastKey = key;
    if (this.isKeysBloqued) {
      e.stopPropagation();
      e.preventDefault();
      if (this.showModalOTT) this.showModalOTT();
    } else {
      this.pressTimer = setTimeout(this.resetTimer, this.delayKeyTime);
    }
  }

  handleChannelChange(e, number) {
    e.preventDefault();
    e.stopPropagation();
    if (this.timerDelayChannelChange) clearTimeout(this.timerDelayChannelChange);
    this.lastNumberPressed = `${this.lastNumberPressed}${number}`;
    const currentLength = this.lastNumberPressed.length;
    if (this.refs.channelNumber && currentLength <= this.maxLenNumberChannel) {
      this.refs.channelNumber.innerHTML = this.lastNumberPressed;
      this.refs.channelNumber.className = 'epg-channel-number';
    }
    if (currentLength == this.maxLenNumberChannel) {
      this.channelChangeHandler(this.lastNumberPressed);
    } else if (currentLength < this.maxLenNumberChannel) {
      this.timerDelayChannelChange = setTimeout(() => {
        this.channelChangeHandler(this.lastNumberPressed);
      }, this.delayChannelChange);
    }
  }

  channelChangeHandler(newChannel) {
    this.timerDelayChannelChange = null;
    new ChannelSingleton().getChannels().then(channels => {
      const channelIndex = channels.findIndex(channel => channel.id == newChannel);
      const channel =
        channelIndex >= 0
          ? channels[channelIndex]
          : Utils.getClosestChannel(parseInt(newChannel), channels);

      if (channel) {
        if (channel.group_id !== this.searchedGroupId) {
          this.changeFirstChannelEPG = true;
          this.searchedGroupId = channel.group_id;
          this.changeNumeric = true;
          this.forceUpdate();
          if (this.refs.channelNumber) {
            this.refs.channelNumber.innerHTML = this.lastNumberPressed;
            this.resetChannelNumberId = setTimeout(() => {
              this.refs.channelNumber.innerHTML = '';
              this.refs.channelNumber.className = '';
              this.resetChannelNumberId = null;
              this.lastNumberPressed = '';
            }, this.delayChannelChange);
          }
        }
      }
    });
  }

  clearTimeoutAutoHide = () => {
    return;
    //console.log('[PAU]> clearTimeoutAutoHide');
    if (this.autoHideTimeoutId) clearTimeout(this.autoHideTimeoutId);
  };

  setAutoHideTimeout = () => {
    return;
    if (this.autoHideTimeoutId) clearTimeout(this.autoHideTimeoutId);
    // console.log('[dann] [Epg Container]: setAutoHideTimeout');
    const autoHideSeconds = Utils.miniFullEpgAutoHideSeconds('epg_auto_hide_seconds', 30);
    //console.log('[PAU]> epg/index reset setAutoHideTimeout, autoHideSeconds: ', autoHideSeconds);
    this.autoHideTimeoutId = setTimeout(() => {
      // console.log('[dann] [Epg Container]: setAutoHideTimeout setTimeout');
      // console.log('[PAU]> Se cierra Full EPG');
      this.props.hideEpgOutside();
    }, autoHideSeconds * 1000);
  };

  componentDidMount() {
    Utils.hideSkipIntro();
    //console.log('[PAU]> [EPG] componentDidMount', this.epgContainer);
    if (this.props.checkStatusEPG) this.setAutoHideTimeout();

    this.epgContainer && this.epgContainer.addEventListener('keydown', this.handleKeyPress);
    new ChannelSingleton().getFilters().then(this.setFilter);
    new ChannelSingleton().getChannels().then(this.setChannels);
    if(this.props.user.type === IPTV){
      this.props.setResumeData({
        title: null,
        description: null,
        previewImage: null,
        image_still: null,
        year: null,
        schedule: null,
        rating: null,
        category: null,
        duration: null,
        purchaseButtonInfo: null,
        showBack: false,
        seasonsText: null,
        eventStatus: null,
        recordable: null,
        timeshift: null,
        showActionBtns: false,
        playButton: null,
        langButton: null,
        favouriteButton: null
      });
    }
    if (Utils.isModalHide()) {
      window.SpatialNavigation.focus('.color-codes .focusable');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      (this.props.groupId == undefined && nextProps.groupId == undefined) ||
      (this.props.groupId == nextProps.groupId &&
        nextProps.checkStatusEPG == this.props.checkStatusEPG &&
        nextProps.filterEpg == this.props.filterEpg)
    ) {
      return;
    }

    this.readyToRender = false;
    //debugger
    if (nextProps.checkStatusEPG) {
      // console.log('[PAU]> epg/index componentWillReceiveProps this.props: ', this.props.style.display);
      // console.log('[PAU]> epg/index componentWillReceiveProps nextProps: ', nextProps.style.display);
      this.setAutoHideTimeout();
    }
    let index_filter = null;
    let node_id_filter = null;

    if (this.filters && this.filters[0]) {
      // Si viene filter (desde carruseles por ejemplo)
      if (!isNaN(parseInt(nextProps.filterEpg))) {
        if (this.filters[nextProps.filterEpg]) {
          index_filter = nextProps.filterEpg;
          node_id_filter = this.filters[nextProps.filterEpg].id;
        }
      }
      // Si no trae filter (desde nodo TV por ejemplo)
      else {
        //index_filter = 0;
        //node_id_filter = this.filters[0].id;
        let filterCurrent = {
          node_id: null,
          index: null
        };
        new ChannelSingleton().getChannels().then(channels => {
          this.readyToRender = true;
          this.setState({ channels, filterCurrent });
        });
      }
    }

    if (!isNaN(parseInt(index_filter)) && node_id_filter) {
      let filterCurrent = {
        node_id: node_id_filter,
        index: index_filter
      };
      // Tenemos que esperar por el singleton, a que recupere todos los canales desde Apis
      new ChannelSingleton().getChannels().then(channels => {
        //debugger
        this.readyToRender = true;
        const dataFavorited = this.filters[nextProps.filterEpg];
        const isFavorited = dataFavorited && dataFavorited.isFavorite || false;
        const defaultNodeID = this.filters[0] && this.filters[0].id || null;
        channels = index_filter > 0 ? this.getFiltered(isFavorited ? defaultNodeID : node_id_filter) : channels;
        this.setState({ channels, filterCurrent });
      });
    }
    if (nextProps.checkStatusEPG && this.state.temporalgroupId) {
      this.readyToRender = true;
      this.setState({ temporalgroupId: false });
    }
    console.log('[EPEGE] epg container willreceive nextProps: ', nextProps);
  }

  componentDidUpdate(prevProps) {
    //console.log('[EPGFILTER] componentDidUpdate', this.epgContainer);
    this.epgContainer && this.epgContainer.removeEventListener('keydown', this.handleKeyPress);
    this.epgContainer && this.epgContainer.addEventListener('keydown', this.handleKeyPress);
    if (Utils.isModalHide() && this.props.checkStatusEPG !== prevProps.checkStatusEPG) {
      window.SpatialNavigation.focus(
        '.epg-container.full-epg .epg-events-container .focusable'
      );
    }
  }

  componentWillUnmount() {
    console.log('[EPG] componentWillUnmount containers EPG', this.epgContainer);
    document.removeEventListener('sn:willunfocus', this.willUnFocusHandler);
    this.epgContainer && this.epgContainer.removeEventListener('keydown', this.handleKeyPress);
    clearTimeout(this.setResumeDataTimeoutId);
    clearTimeout(this.autoHideTimeoutId);
  }

  toggleContent() {
    const showEpg = !this.state.showEpg;
    this.setState({ showEpg });
    if (showEpg) {
      if (this.props.getEpgType() == 'GUIDE') {
        this.props.setEpgType('MOSAIC');
        this.sendMetric('canales');
      } else {
        this.props.setEpgType('GUIDE');
        this.sendMetric('programacion');
      }
    } else {
      if (this.props.getEpgType() == 'MOSAIC') {
        this.props.setEpgType('GUIDE');
        this.sendMetric('programacion');
      } else {
        this.props.setEpgType('MOSAIC');
        this.sendMetric('canales');
      }
    }
  }

  getContentBtn() {
    const showEpg = this.state.showEpg;
    const text =
      this.props.getEpgType() === 'GUIDE'
        ? Translator.get('tv_channels_title', 'Canales')
        : Translator.get('tv_programming_button', 'Programación');
    const icon = this.props.getEpgType() === 'GUIDE' ? 'fa-th' : 'fa-th-list';
    return (
      <div>
                <span className="icon">
                    <i className={`fa ${icon}`} aria-hidden="true" />
                </span>{' '}
        {text}
      </div>
    );
  }

  setChannels(channels) {
    if (this.props.filterEpg !== null) {
      new ChannelSingleton()
        .getFilteredChannels(this.state.filterCurrent.node_id)
        .then(async availableChannels => {
          if (availableChannels.length == 0) {
            availableChannels.push({ groupId: this.state.filterCurrent.node_id });
          }
          this.searchedGroupId = availableChannels[0].group_id;
          //console.log('EPGFILTER setChannels available: ', availableChannels);
          this.setState({ channels: availableChannels });
        });
    } else {
      this.setState({ channels });
    }
  }

  setFilter(filters) {
    //debugger
    //console.log('PAPAU EPGFILTER setFilter en epg container [Filtro desde guia Tv]', this.updateFilter);
    //console.log('nuevo node_id', this.node_id);
    //console.log('EPGFILTER nuevo filterEPG: ', this.props.filterEpg);
    if (!filters) {
      return null;
    }

    let filterCurrent = this.state.filterCurrent;
    let handleIndex = 0;

    if (this.props.filterEpg !== null) {
      try {
        handleIndex = parseInt(this.props.filterEpg);
      } catch (e) {
        handleIndex = 0;
      }
      //console.log("[Epg] setfilter filterEpg", handleIndex);
      //delete this.props.filterEpg;
    } else if (this.updateFilter) {
      filters.map((it, i) => {
        if (this.node_id == it.id) handleIndex = i;
      });
      //console.log("[Epg] setfilterEpg updateFilter", handleIndex);
    }

    if (filters.length) {
      filterCurrent = {
        node_id: filters[handleIndex].id,
        index: handleIndex
      };
    }
    //console.log("[Epg] setFilter", filterCurrent);

    this.filters = filters;
    //this.loadedFilter=filterCurrent.node_id;
    this.setState({ filterCurrent });
  }

  clearFilter() {
    if (this.filters && this.filters[0] && this.filters[0].id) {
      let filterCurrent = {
        node_id: this.filters[0].id,
        index: 0
      };

      this.setState({ filterCurrent });
    }
  }

  currentFilter() {
    //debugger
    //const current = this.state.filterCurrent;
    let current = this.loadedFilter ? this.loadedFilter : this.state.filterCurrent;
    let index = current.index;
    if (index === null) {
      index = 0;
    }

    return { index, filter: this.filters[index] };
  }

  prevFilter() {
    let current = this.loadedFilter ? this.loadedFilter : this.state.filterCurrent;
    if (current.index === null) {
      if (this.filters && this.filters[0]) {
        current.index = 0;
      }
    }
    const index = parseInt(current.index) === 0 ? this.filters.length - 1 : current.index - 1;

    /*
console.log('[Epg] prevFilter',
  '\n current', current,
  '\n prev', index);
*/
    return { index, filter: this.filters[index] };
  }

  nextFilter() {
    //debugger
    let current = this.loadedFilter ? this.loadedFilter : this.state.filterCurrent;
    if (current.index === null) {
      if (this.filters && this.filters[0]) {
        current.index = 0;
      }
    }
    const index =
      this.filters.length > parseInt(current.index) + 1 ? parseInt(current.index) + 1 : 0;
    /*console.log('[Epg] nextFilter',
 '\n current', current,
 '\n next', index,
 '\n this.filters', this.filters);
 */
    return { index, filter: this.filters[index] };
  }

  // setPrevFilter() {
  //   if (this.props.checkStatusEPG) {
  //     this.setAutoHideTimeout();
  //   }
  //   this.sendMetric(this.getPrevFilterName());
  //   const prev = this.prevFilter();
  //   // antes del cambio de estado, se resetea el loaded filter con el que entró, si es que fue así
  //   if (this.loadedFilter) {
  //     this.loadedFilter = null;
  //   }
  //   const filterCurrent = { node_id: prev.filter.id, index: prev.index };
  //   this.changeFilter(filterCurrent);
  // }
  yellowHandler() {
    // TO DO
    this.props.handleFullEpg();
    this.isInColors = false;
  }


  redHandler() {
    ModalEpgUtils.redHandler({hideEpgOutsideCb: this.props.hideEpgOutside, handleGuideCb: this.handleGuide});
  }

  blueHandler = async (focusEvent)=>{
    if(this.props && typeof (this.props.hideEpgOutside === 'function')){
      this.props.hideEpgOutside();
    }
    const {group_id = null} = focusEvent || {};
    const isSusc = await this.playerStreamingUtils.checkSusc(null, group_id, this.handleGuide, focusEvent); 
    if(isSusc){
      // SE MUESTRA MODAL DE OPCIONES
      ModalEpgUtils.blueHandler({
        hideEpgOutsideCb: this.props.hideEpgOutside, 
        handleGuideCb: this.handleGuide, 
        data: focusEvent, 
        streamType: this.props.streamType, 
        streamContentType: this.props.streamContentType(), 
        changeLangCb: this.props.changeLangCb, 
        from: EpgConstants.FROM_FULL_EPG, 
        showFullEpg: this.props.showFullEpg});
    }
  }

  changeFilter(filterCurrent) {
    //console.log('[EPGFILTER] Epg changeFilter ', filterCurrent);
    new ChannelSingleton()
      .getFilteredChannels(filterCurrent.node_id)
      .then(async availableChannels => {
        //this.loadedFilter=filterCurrent.node_id;
        if (availableChannels.length == 0) {
          availableChannels.push({ groupId: filterCurrent.node_id });
        }
        this.searchedGroupId = availableChannels[0].group_id;
        this.changeByFilter = true;
        this.setState({ filterCurrent, channels: availableChannels });
      });
  }

  // setNexFilter() {
  //   if (this.props.checkStatusEPG) {
  //     this.setAutoHideTimeout();
  //   }

  //   this.sendMetric(this.getNextFilterName());
  //   const next = this.nextFilter();
  //   // antes del cambio de estado, se resetea el loaded filter con el que entró, si es que fue así
  //   if (this.loadedFilter) {
  //     this.loadedFilter = null;
  //   }
  //   const filterCurrent = { node_id: next.filter.id, index: next.index };
  //   this.changeFilter(filterCurrent);
  // }

  getCurrentFilterName() {
    const current = this.currentFilter();
    let textName = '';
    if(current && current.filter){
      const filter = current.filter;
      const defaultText = filter.text || '';
      const capitalizeText = `Canales de ${(defaultText && (typeof defaultText === 'string') ? defaultText.toLowerCase() : '')}`;
      const firstFilter = this.filters && Array.isArray(this.filters) && this.filters[0];
      const isFirst = firstFilter && filter &&  firstFilter.id &&  filter.id && firstFilter.id === filter.id;
      if(filter && filter.code && filter.code === EpgConstants.FAV_CODE_ITEM){
        // nombre para el filtro de favoritos.
        textName = Translator.get(`playingLive_fullEpg_title_favoritesChannels_label`,'Canales Favoritos');
      }else{
        textName = isFirst ? '' : Translator.get(`${filter.code || ''}_categorie_description_label`,capitalizeText);
      }
      
    }
    return textName;
  }

  // getPrevFilterName() {
  //   const prev = this.prevFilter();

  //   return prev.filter ? prev.filter.text : '...';
  // }

  // getNextFilterName() {
  //   const next = this.nextFilter();

  //   return next.filter ? next.filter.text : '...';
  // }

  setResumeDataTimeout(data) {
    if (this.setResumeDataTimeoutId) {
      clearTimeout(this.setResumeDataTimeoutId);
    }

    this.setResumeDataTimeoutId = setTimeout(this.setResume, 1000, data);
  }

  /*
// Sólo para debug por el momento, pero parece que funciona bien
// Nota: shouldComponentUpdate este método no esta(ba) definido dentro de este contenedor
shouldComponentUpdate(nextProps, nextState) {
  let a = Utils.removeFunctionProperty(nextProps);
  let b = Utils.removeFunctionProperty(this.props);

  let c = nextState;
  let d = this.state;


  let e = JSON.stringify(a) === JSON.stringify(b);
  let f = JSON.stringify(c) === JSON.stringify(d);

  return !(e && f);
}
*/

  setResume(data) {
    if (data.event && LayersControl.isPlayerVisible()) {
      const { event } = data;

      if (!isNaN(event.date_begin)) {
        event.date_begin = new Dates().unix(event.date_begin).format('YYYY/MM/DD HH:mm:ss');
      }
      if (!isNaN(event.date_end)) {
        event.date_end = new Dates().unix(event.date_end).format('YYYY/MM/DD HH:mm:ss');
      }

      const start = new Dates(event.date_begin, 'YYYY/MM/DD HH:mm:ss');
      const end = new Dates(event.date_end, 'YYYY/MM/DD HH:mm:ss');
      const durationParsed = `${start.format('HH.mm')}hs. a ${end.format('HH.mm')}hs.`;

      this.currentData = data;
      // this.setState({ currentData: data });
      this.props.setResumeData({
        title: event.name,
        description: event.description,
        previewImage: event.ext_eventimage_name.replace('https', 'http'),
        year: event.ext_year,
        schedule: durationParsed,
        rating: event.parental_rating,
        category: event.dvb_content,
        duration: event.duration ? Utils.formatDuration(event.duration) : null,
        purchaseButtonInfo: null,
        showBack: false,
        seasonsText: null,
        image_still: null,
        recordable: event.ext_recordable === '1',
        timeshift: event.ext_catchup === '1',
        eventStatus: new Npvr().getEventStatus(event.id),
        showActionBtns: false,
        playButton: null,
        langButton: null,
        favouriteButton: null,
        isLive: true
      });
    }
  }

  updateEpg(channel, fromCoverFlow = false) {
    if (typeof this.props.onUpdateEpg == 'function') {
      this.props.onUpdateEpg(channel.group_id, fromCoverFlow);
    }
  }

  enableKeyActions() {
    this.keyActionsEnabled = true;
  }

  disableKeyActions() {
    this.keyActionsEnabled = false;
  }

  sendDimension() {
    const payload = new AnalyticsDimensionSingleton().getPayload();
    this.props.setMetricsEvent(payload);
    this.props.setMetricsEvent({ type: 'executor' });
  }

  sendVirtualPage(virtualPage) {
    if (typeof this.props.setMetricsEvent === 'function') {
      this.props.setMetricsEvent({
        hitType: 'pageview',
        page: virtualPage
      });
      this.props.setMetricsEvent({ type: 'executor' });
    }
  }

  sendMetric(label) {
    if (typeof this.props.setMetricsEvent === 'function') {
      this.props.setMetricsEvent({
        hitType: 'event',
        eventCategory: 'tv',
        eventAction: 'menu',
        eventLabel: label
      });
      this.props.setMetricsEvent({ type: 'executor' });
      this.sendDimension();
    }
  }

  openSearch = () => {
    this.sendMetric('buscar');
    this.props.goToCard('/search');
  };

  requestHandler = (request, state, value, icon = '') => {
    if (state === 'isReminder' && !value) {
      request = new ReminderDeleteTask(this.state.idReminder);
    }
    RequestManager.addRequest(request)
      .then(resp => {
        if(resp.lasttouch && resp.lasttouch.reminder) { // set new lasttouch Reminder in redux
          const lastTouchReminder = resp.lasttouch.reminder;
          store.dispatch(setLastTouchReminder(lastTouchReminder));
        }
        if (resp.response) {
          if (value) {
            this.props.showNotification({
              show: true,
              title: this.state.messages[state].title,
              msg: this.state.messages[state].message,
              faClass: icon,
              type: 'message'
            });
          }
          if (state === 'isReminder') {
            ReminderNotifications.setReminders(
              parseInt(Metadata.get('sentinel_reminders_interval', 30)),
              false
            );
          }
        } else {
          console.log('Error', resp.response);
          const modal = {
            modalType: AAF_MODAL_ERROR,
            modalProps: {
              content: resp.errors.error[0]
            }
          };
          this.props.showModal(modal);
        }
      })
      .catch(err => {
        console.error('Error:', err);
        if (err.code === 'error_channel_exists') {
          this.setState({ [state]: true });
        } else if (err.code === 'error_channel_not_exists') {
          this.setState({ [state]: false });
        } else {
          const modal = {
            modalType: AAF_MODAL_ERROR,
            modalProps: {
              content: err
            }
          };
          this.props.showModal(modal);
        }
      });
  };

  canTimeShift(event) {
    const timeshiftAllowed = ChannelSingleton.getTimeshift(event.channel_group_id) * 60;
    const now = new Dates(Utils.now());
    const diffStart = now.diff(new Dates(event.date_begin), 'seconds');
    const startMatch = diffStart <= timeshiftAllowed;
    const diffEnd = now.diff(new Dates(event.date_end), 'seconds');
    const endMatch = diffEnd <= timeshiftAllowed;
    const dateBegin = startMatch
      ? event.date_begin
      : now.subtract(timeshiftAllowed, 'seconds').format('YYYY/MM/DD HH:mm:ss');
    return diffStart > 0 && (startMatch || endMatch) ? dateBegin : false;
  }

  modalOttOpenSearchAction = () => {
    this.hideModal();
    this.openSearch();
  };

  modalOttAddReminderAction = () => {
    const event = this.currentData.event;
    const canTimeShift = this.canTimeShift(event);
    const dateBegin = canTimeShift ? canTimeShift : event.date_begin;
    const exp_date = dateBegin.replace(/\/|\s|:/g, '');
    const event_id = event.id;
    const type_event = event.type != '0' ? event.type : 'epg_serie';
    const channel_id = event.channel_id;

    const reminderCreateRequest = new ReminderCreateTask(
      event_id,
      exp_date,
      type_event,
      channel_id
    );
    this.requestHandler(reminderCreateRequest, 'isReminder', true, 'fa-clock-o');
  };

  modalOttNpvrAddAction = () => {
    const event = this.currentData.event;
    this.props.record(event);
  };

  modalOttPlayAction = () => {
    if (this.currentData.channel.group_id !== null) {
      this.props.hideEpgOutside();
      let newChannel = {
        playerstate: 'PLAYING',
        source: {
          videoid: this.currentData.channel.group_id
        },
        size: {
          top: 0,
          left: 0,
          width: 1280,
          height: 720
        },
        ispreview: false,
        islive: true,
        ispip: false
      };
      store.dispatch(playFullMedia(newChannel));
    }
    this.hideModal();
  };

  modalOttMoreInfoAction = () => {
    if (this.currentData.channel.group_id !== null) {
      const eventData = JSON.stringify({ event: this.currentData.event });
      this.props.hideEpgOutside();
      this.props.goToCard(
        `/epg/${this.currentData.channel.group_id}?eventData=${encodeURI(eventData)}`
      );
    }
    this.hideModal();
  };

  modalOttChannelsAction = () => {
    this.toggleContent();
    this.hideModal();
  };

  showModalOTTCategoryAction = () => {
    if (this.filters.length > 0) {
      const menuFilter = this.filters.map((item, index) => {
        return {
          title: item.text,
          action: () => {
            const filter = { node_id: item.id, index: index };
            this.changeFilter(filter);
            this.hideModal();
          }
        };
      });

      store.dispatch(
        showModal({
          modalType: MODAL_CHANNEL_EPG,
          modalProps: {
            menuItems: menuFilter
          }
        })
      );
    }
  };

  showModalOTTGoToMenuAction = () => {
    this.goToMenu();
    this.hideModal();
  };

  goToMenu = () => {
    this.props.hideEpgOutside();
    store.dispatch(playFullMedia({ src: null, event: null }));
    this.props.goToCard(`/node/${getLinksFromNavConfiguration().home}`);
  };

  hideModal = () => {
    store.dispatch({
      type: HIDE_MODAL,
      modalType: MODAL_EPG
    });
  };

  focusSearchColor = () => {
    this.isInColors = true;
  };

  setMoreInfoFunction = func => {
    this.setState({ moreInfoFunction: func });
  };

  /**
   * @param {*} nextChannel = {id: next_group_id}
   */
  setChannelInfo(nextChannel) {
    if (nextChannel.fromCoverFlow) this.setState({ temporalgroupId: nextChannel.id });
    else this.setState({ groupId: nextChannel.id });
  }

  getFiltered(node_id) {
    let chs = new ChannelSingleton();
    return chs.getFilteredChannelsByNode(node_id);
  }

  getChannelsToDisplay() {
    //debugger
    let availableChannels = null;
    let filterCurrent = null;
    if (
      this.state.filterCurrent &&
      this.state.filterCurrent.node_id &&
      parseInt(this.state.filterCurrent.node_id) > -1 &&
      !this.changeNumeric
    ) {
      let indexFilter = this.filters.findIndex(filter => {
        return filter.id == this.state.filterCurrent.node_id;
      });

      if (this.filters && !isNaN(parseInt(indexFilter)) && this.filters[indexFilter]) {
        filterCurrent = {
          node_id: this.filters[indexFilter].id,
          index: indexFilter
        };
        this.loadedFilter = filterCurrent;
        availableChannels = this.getFiltered(filterCurrent.node_id);
        //console.log('[EPGFILTER] Epg getChannelsToDisplay availableChannels despues del promise ', availableChannels);
        if (availableChannels && availableChannels.length == 0) {
          availableChannels.push({ groupId: filterCurrent.node_id });
        }
        if (availableChannels && availableChannels[0]) {
          this.searchedGroupId = availableChannels[0].group_id;
        }
      }
    } else {
      this.loadedFilter = null;
    }

    return availableChannels;
  }

  render() {
    // Aún oculta la EPG o no, necesitamos actualizarla en el show o en el hide...
    // NOTA: readyToRender no significa show, significa update de EPG.
    if (!this.readyToRender) {
      console.log('======== NO RENDER YET ======= IPIGI readyToRender es false');
      return null;
    }
    //debugger
    //console.log('[PAPAU] [EPGFILTER] Epg render this.props, this.state: ', this.props, this.state);
    let avaiChannels = this.getChannelsToDisplay();
    this.changeNumeric = false;
    let node_idToDisplay = avaiChannels
      ? this.loadedFilter.node_id
      : this.state.filterCurrent.node_id;
    if (node_idToDisplay === null && this.state.filterCurrent.node_id === null) {
      node_idToDisplay = this.filters && this.filters[0] && this.filters[0].id;
    }

    let channelToDisplay = avaiChannels || this.state.channels;
    //console.log('[EPGFILTER] Epg render, setChannels, avaiChannels: ', avaiChannels, this.state.filterCurrent, this.props.filterEpg, this.state.channels);
    if (!node_idToDisplay || !this.state.channels) {
      return null;
    }
    /*
if(this.state.filterCurrent.node_id !== this.loadedFilter)
{
  return null
}
*/
    const showEpgPostales = Device.getDevice().getConfig().useEpgPostals;
    const groupId =
      this.state.temporalgroupId ||
      this.searchedGroupId ||
      this.state.groupId ||
      this.props.groupId ||
      (this.state.channels && this.state.channels[0] && this.state.channels[0].group_id);

    this.searchedGroupId = null;
    //const indexChannel = this.state.channels.findIndex(channel => channel.group_id == groupId);
    //const totalChannels = this.state.channels.length;
    const indexChannel = channelToDisplay.findIndex(channel => channel.group_id == groupId);

    const totalChannels = channelToDisplay.length;
    const visibleRows = 5;
    let verticalOffset = 2;
    verticalOffset = showEpgPostales ? verticalOffset * visibleRows : verticalOffset;

    const { from, quantity, infinite_fix } = Utils.getEpgRange(
      indexChannel,
      totalChannels,
      verticalOffset,
      visibleRows,
      true
    );

    //console.log('[EPGFILTER] Epg render groupId ', groupId, indexChannel, totalChannels, verticalOffset, visibleRows, from, quantity, infinite_fix);
    //console.log('[EPGFILTER] Epg render  indexChannel ', indexChannel);
    //console.log('[EPGFILTER] Epg render  totalChannels ', totalChannels);
    //console.log('[EPGFILTER] Epg render  verticalOffset ', verticalOffset);
    //console.log('[EPGFILTER] Epg render  visibleRows ', visibleRows);
    //console.log('[EPGFILTER] Epg render  from ', from);
    //console.log('[EPGFILTER] Epg render  infinite_fix ', infinite_fix);

    const epgProps = {
      //node_id: this.state.filterCurrent.node_id,
      node_id: node_idToDisplay,
      //levelChannels: this.state.channels,
      levelChannels: channelToDisplay,
      onSetCurrentData: data => {
        this.setResumeDataTimeout(data);
        this.isInColors = false;
      },
      onFirstLoad: data => this.setResume(data),
      handleEPG: () => {
        this.props.handleFullEpg();
      },
      isFullEpg: true,
      enableColorActions: this.enableKeyActions,
      disableColorActions: this.disableKeyActions,
      updateEpg: this.updateEpg,
      playPipPlayer: this.playPipPlayer,
      closePipPlayer: this.closePipPlayer,
      closeFullPlayer: this.closeFullPlayer,
      killPipTimeout: this.killPipTimeout,
      verticalOffset,
      visibleRows,
      from: from < 0 ? 0 : from, //: (this.state.filterCurrent && this.state.filterCurrent.index && parseInt(this.state.filterCurrent.index ) > 0) ? 0 : from,
      quantity,
      infinite_fix,
      setMetricsEvent: this.props.setMetricsEvent,
      hideEpgOutside: this.props.hideEpgOutside,
      onChangingChannel: this.props.onChangingChannel,
      isChangingChannel: this.props.isChangingChannel,
      setEpgError: this.props.setEpgError,
      hasEpgError: this.props.hasEpgError,
      //showCoverFlow: this.props.showCoverFlow,
      setMoreInfoFunction: this.setMoreInfoFunction,
      showActionBar: this.props.showActionBar,
      hideActionBar: this.props.hideActionBar,
      goToCard: this.props.goToCard,
      user: this.props.user,
      modalOttPlayAction: this.modalOttPlayAction,
      modalOttMoreInfoAction: this.modalOttMoreInfoAction,
      modalOttNpvrAddAction: this.modalOttNpvrAddAction,
      modalOttAddReminderAction: this.modalOttAddReminderAction,
      modalOttChannelsAction: this.modalOttChannelsAction,
      showModalOTTCategoryAction: this.showModalOTTCategoryAction,
      modalOttOpenSearchAction: this.modalOttOpenSearchAction,
      showModalOTTGoToMenuAction: this.showModalOTTGoToMenuAction,
      focusSearchColor: this.focusSearchColor,
      isPlayingLiveAsFull: this.props.isPlayingLiveAsFull,
      receiveOK: this.props.receiveOK,
      fullToHide:
        (this.props.style && this.props.style.display && this.props.style.display) == 'none'
          ? true
          : false,
      changeFirstChannelEPG: this.changeFirstChannelEPG,
      changeByFilter: this.changeByFilter ? this.changeByFilter : null
    };

    const checkStatusEpg = {
      checkStatusEPG: this.props.checkStatusEPG,
      checkStatusCoverFlowCH: this.props.checkStatusCoverFlowCH
    };

    const onRefEpgContainerSucceded = div => {
      console.log('[EPG] onRefEpgContainerSucceded ', div);
      this.epgContainer &&
      this.epgContainer.removeEventListener('keydown', this.handleKeyPress);
      this.epgContainer = div;
      this.epgContainer && this.epgContainer.addEventListener('keydown', this.handleKeyPress);
      return this.epgContainer;
    };

    const nodoTV = Utils.getApaMetadataKey('links_nav_configuration', '{}', 'clarotv')
    const user = store.getState().user.userStatus;
    

    return (
      <div
        className="epg-container full-epg"
        ref={onRefEpgContainerSucceded}
        style={this.props.style}
      >
        <div className="epg-wrapper">
          <div id="channelContainerNumber" className="" ref="channelNumber" />
          <div id="resume-wrapper" />
          <EpgHeader
            title={this.getCurrentFilterName()}
            // yellowContent={<span>{this.getPrevFilterName()}</span>}
            yellowHandler={this.yellowHandler}
            // greenContent={<span>{this.getNextFilterName()}</span>}
            // greenHandler={this.setNexFilter}
            redHandler={this.redHandler}
            blueHandler={this.blueHandler}
            contentBtn={this.getContentBtn()}
            contentHandler={this.toggleContent}
            moreInfoVisibility={this.state.showEpg}
            goToMenu={this.goToMenu}
            moreInfoFunction={this.state.moreInfoFunction}
          />
          {this.props.showEpg && !this.channelsFlag && !epgProps.fullToHide ? (
            (
              <FullEpgPersistance
                show={this.props.showEpg ? true : false}
                handleFullEpg={this.props.handleEpg}
                filterEpg={
                  this.props.filterEpg ? this.filters[this.props.filterEpg] : null
                }
                hideEpgOutside={this.props.hideEpgOutside}
                yellowHandler={this.yellowHandler}
                redHandler={this.redHandler}
                blueHandler={this.blueHandler}
                nodeId={node_idToDisplay}
                refChannel={this.refs}
                goToCard={this.props.goToCard}
                handleMosaic={this.handleMosaic}
                handleGuide={this.handleGuide}
                clearTimeoutAutoHide={this.clearTimeoutAutoHide}
                setAutoHideTimeout={this.setAutoHideTimeout}
                record={this.props.record}
                streamType={this.props.streamType}
                streamContentType={this.props.streamContentType}
                changeLangCb={this.props.changeLangCb}
                getCurrentEvent={this.props.getCurrentEvent}
                setMetricsEvent={this.props.setMetricsEvent}
                showFullEpg = {this.props.showFullEpg}
              />
            )
          ) : !epgProps.fullToHide ? (
            <ChannelGrid
              request={{
                uri: 'level',
                params: {
                  //node_id: this.state.filterCurrent.node_id,
                  node_id: node_idToDisplay,
                  quantity: 15,
                  from: 0,
                  node: nodoTV, //buscado
                  user_status: user, //buscado
                  isCurrentNodoTV: true, //Lianet comenta que este siempre es el valor aqui
                  epg_version: LocalStorage.getItem('epgVersion') || false, //buscado
                  soa_version: LocalStorage.getItem('soaVersion') || false
                }
              }}
              rows={3}
              cols={5}
              gridTyp={0}
              setMetricsEvent={this.props.setMetricsEvent}
              onHide={this.props.hideEpgOutside}
              modalOttChannelsAction={this.modalOttChannelsAction}
              showModalOTTCategoryAction={this.showModalOTTCategoryAction}
              modalOttOpenSearchAction={this.modalOttOpenSearchAction}
              showModalOTTGoToMenuAction={this.showModalOTTGoToMenuAction}
              showActionBar={this.props.showActionBar}
              hideActionBar={this.props.hideActionBar}
              yellowHandler={this.yellowHandler}
              greenHandler={this.setNexFilter}
              setResumeData={this.props.setResumeData}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

Epg.contextTypes = {
  router: React.PropTypes.object.isRequired
};

const mapStateToProps = state => ({ user: state.user });

export default connect(
  mapStateToProps,
  { setResumeData, playFullMedia, setMetricsEvent, showNotification, showModal },
  null,
  { withRef: true }
)(Epg);



// WEBPACK FOOTER //
// ./src/containers/Epg/index.jsx